import { connect } from 'react-redux'
import SearchBox from './SearchBox'
import { searchChannelCommunications } from '../../dataStore/slices/communications'

const mapDispatchToProps = dispatch => ({
  onChange: (id, query) => dispatch(searchChannelCommunications(query))
})

export default connect(null, mapDispatchToProps)(SearchBox)
